var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Activity_1;
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
export var ActivityType;
(function (ActivityType) {
    ActivityType["Usage"] = "usage";
    ActivityType["Credit"] = "credit";
})(ActivityType || (ActivityType = {}));
const schema = {
    $id: 'urn:wisepipe-usages-domain:Activity',
    type: 'object',
    properties: {
        activityID: { type: 'string', uid: 9 },
        activityType: { type: 'string', enum: Object.values(ActivityType) },
        date: { type: 'string', format: 'date-time' },
        value: { type: 'number' },
        details: { type: 'array', items: { type: 'string', minLength: 1 } },
        orgID: { type: 'string', minLength: 0, maxLength: 128 },
        userID: { type: 'string', minLength: 0, maxLength: 128 },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) }
    },
    required: ['activityID', 'activityType', 'date', 'value', 'details']
};
let Activity = Activity_1 = class Activity {
    constructor(activityID, activityType, date, value, details, orgID, userID, orgPlan) {
        this.activityID = activityID;
        this.activityType = activityType;
        this.date = date;
        this.value = value;
        this.details = details;
        this.userID = userID;
        this.orgID = orgID;
        this.orgPlan = orgPlan;
        JSON.validate(this, Activity_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(base64ID) {
        return Utils.base64StringToBuffer(base64ID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], Activity.prototype, "date", void 0);
Activity = Activity_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorProperty('activityType')
], Activity);
export { Activity };
//# sourceMappingURL=activity.js.map